<template>
  <v-container class="pb-0">
    <v-expansion-panel readonly expand v-model="openPanel">
      <v-expansion-panel-content class="grey lighten-4 elevation-3">
        <span class="title" slot="header">{{ panelName }}</span>
        <v-icon slot="actions"></v-icon>
        <v-card>
          <v-card-text>
            <slot></slot>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-container>
</template>

<script>
export default {
  props: {
    panelName: String
  },
  data() {
    return {
      openPanel: [true]
    };
  },
  methods: {}
};
</script>

<style>
</style>
